import {Component, input, InputSignal} from '@angular/core';

@Component({
  selector: 'icon-globe',
  imports: [],
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" [attr.width]="size()" [attr.height]="size()"
         viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5" />
      <path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5"
            d="M8 12c0 6 4 10 4 10s4-4 4-10-4-10-4-10-4 4-4 10Z" />
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
            d="M21 15H3M21 9H3" />
    </svg>
  `
})
export class IconGlobeComponent {
  size: InputSignal<number> = input<number>(24);
}
